module.exports = __webpack_public_path__ + "static/media/hotel_2.8b82d3f8.svg";